import { createApp } from 'vue'
import App from '../components/publicRelations/components/completedProject/CompletedProject.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import VueSplide from '@splidejs/vue-splide'
import VueGoogleMaps from '@fawmi/vue-google-maps'
import '@splidejs/vue-splide/css'
import '@splidejs/vue-splide/css/skyblue'
import '@splidejs/vue-splide/css/sea-green'
import '@splidejs/vue-splide/css/core'

window.createPRCompletedProject = function createPRCompletedProject(
  divId,
  props = null
) {
  const app = createApp(App, props)
    .use(ElementPlus)
    .use(VueSplide)
    .use(VueGoogleMaps, {
      load: {
        key: 'AIzaSyCvBM9UWQ73yqMHclkRkLBMlI_VWTSnEqc',
      },
    })
  addAssets(app)
  app.mount(`#${divId}`)
}
